import { fetch_sadap } from "../../core/api";

export const getAll = (data) => {
	return fetch_sadap("employee-biodata/position", "get", data, false);
};

export const getList = (data) => {
	return fetch_sadap("employee-biodata/position/list", "get", data, false);
};
